import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  const featured = articles.find((a) => a.featured);
  const rest = articles.filter((a) => !a.featured);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
              CSSBuy Sheet
              <br />
              <span className="text-foreground-400">SEO Guides</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-sm leading-relaxed">
            In-depth guides and comparisons to help you navigate CSSBuy spreadsheets, find the best deals, and shop with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {featured && (
            <Link
              to={`/${featured.slug}`}
              className="lg:col-span-2 group block bg-background-50 rounded-xl overflow-hidden transition-all hover:bg-background-200/70 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={featured.imageUrl}
                  alt={featured.title}
                  title={featured.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
                  Featured Guide
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">
                  {featured.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {featured.summary}
                </p>
              </div>
            </Link>
          )}

          {rest.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all hover:bg-background-200/70 cursor-pointer"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-3">
                  {article.title}
                </h3>
              </div>
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}